import { lazy } from 'react';

export const userRoles = {
  EXECUTIVE_DIRECTOR: 'Executive Director',
  admin: 'admin',
};

export const productPlans = {
  rbtPremiumPlan: "RBT Premium Plan",
  rbtPlusPlan: "RBT Plus Plan",
  rbtBasicPlan: "RBT Basic Plan",
  bcbaPlusPlan: "BCBA Plus Plan",
  bcbaBasicPlan: "BCBA Basic Plan",
  bcbaPremiumPlan: "BCBA Premium Plan",
};

export const procedureCodes = [
  { code: '97151', component: lazy(() => import('../../SessionNote97151/SessionNoteForm')), name: 'Procedure Code 97151' },
  { code: '97153', component: lazy(() => import('../SessionNotes')), name: 'Procedure Code 97153' },
  { code: '97155', component: lazy(() => import('../../SessionNote97155/SessionNoteForm')), name: 'Procedure Code 97155' },
  { code: '97156', component: lazy(() => import('../../SessionNote97156/SessionNoteForm')), name: 'Procedure Code 97156' },
  // { code: 'H0032', component: lazy(() => import('../../SessionNoteH0032/SessionNoteForm')), name: 'Procedure Code H0032' },
];

export const roleAccess = {
  [userRoles.EXECUTIVE_DIRECTOR]: procedureCodes,
  [userRoles.admin]: procedureCodes,
};

export const productPlanAccess = {
  [productPlans.rbtPremiumPlan]: procedureCodes.filter(code => code.code === '97153'),
  [productPlans.rbtPlusPlan]: procedureCodes.filter(code => code.code === '97153'),
  [productPlans.rbtBasicPlan]: procedureCodes.filter(code => code.code === '97153'),
  [productPlans.bcbaPremiumPlan]: procedureCodes,
  [productPlans.bcbaBasicPlan]: procedureCodes,
  [productPlans.bcbaPlusPlan]: procedureCodes,
};